import React, { useCallback, useMemo, useRef } from "react";
import { IUserFormInput, onReplaceSpecialChars } from "../../pages/UserForm";
import MaterialUiPhoneNumber from "material-ui-phone-number";
import { debounce } from "lodash";

interface IUserPhoneField extends IUserFormInput {
  classes: any;
}

const UserFormPhoneField = ({ label, value, mandatory, onInputChange, classes, characterLimit }: IUserPhoneField) => {
  const valueRef = useRef<string>("");

  const id = useMemo(() => onReplaceSpecialChars(label.toLowerCase().replaceAll(" ", "-")), [label]);

  const handleChange = useCallback(
    debounce((input, ci) => {
      valueRef.current = input ?? "";
      onInputChange(input);
    }, 100),
    []
  );

  const extraProps: any = {};
  let extraLabel = "";
  if (characterLimit && value) {
    // const currentCharacters = (currentValue ?? "").length;
    const numericCharaters = value.replace(/\D/g, "");
    const nonNumericLength = value.length - numericCharaters.length;
    extraProps.inputProps = { maxLength: characterLimit + nonNumericLength };
    // extraProps.InputProps = {
    //   endAdornment: <InputAdornment position="end">{currentCharacters}/{characterLimit}</InputAdornment>,
    // }

    extraLabel = ` (Máx. ${characterLimit} números, incluyendo los números del código del país)`;
  }

  return (
    <MaterialUiPhoneNumber
      id={id}
      name={id}
      fullWidth
      type="new-password"
      autoComplete="new-password"
      label={label + extraLabel}
      margin="normal"
      autoFormat={true}
      variant="outlined"
      required={mandatory}
      defaultCountry={"co"}
      regions={["america"]}
      excludeCountries={["ca"]}
      value={value}
      countryCodeEditable={false}
      className={classes.phoneInput}
      onChange={(value: any, countryInfo) => handleChange(value ?? "", countryInfo)}
      {...extraProps}
    />
  );
};

export default UserFormPhoneField;
